import { FlowType } from '@core/enums/flow-type.enum';
import { EIdentityDocumentType } from '@core/enums/identity-document-type.enum';
import { RecordingType } from '@core/enums/recording-type.enum';
import { BadgeValidity } from '@core/model/badge/badge-validity.model';
import { ByPassInformation } from '@core/model/bypass-information.model';
import { Customer } from '@core/model/customer/customer.model';
import { Aircraft } from '@core/model/entity/aircraft.model';
import { FacesCompareResult } from '@core/model/entity/FacesCompareResult';
import { Reservation } from '@core/model/reservation/reservation.model';
import { Training } from '@core/model/training/training.model';

export class FlowInformation {
  flowType: FlowType;
  facialComparisonResult: FacesCompareResult;
  badgeValidity: BadgeValidity;
  badgePrinted: boolean;
  badgePrintRequest: boolean;
  recordingType: RecordingType;
  byPasses: ByPassInformation[];
  aircraft: Aircraft;
  customer: Customer;
  training: Training;
  reservations: Reservation[];
  covidAcknowledgementDate: Date;
  identityDocumentType: EIdentityDocumentType;
  backButtonDeactivated: boolean;
  hasExtraInformationPage: boolean;
  isScanPassportSuccess: boolean;
  isScanGovernmentIdSuccess: boolean;
  isScanDocumentSuccess: boolean;
  isIdentityComparaisonSuccess: boolean;
  isCheckinSuccess: boolean;
  isIdPictureSuccess: boolean;
  isSelfiePictureSuccess: boolean;
  isPrintBadgeSuccess: boolean;
  isScanQrCodeValidationSuccess: boolean;

  constructor(data?: FlowInformation) {
    this.badgePrintRequest = undefined;
    this.badgePrinted = false;
    this.backButtonDeactivated = false;
    this.hasExtraInformationPage = false;
    this.isScanPassportSuccess = false;
    this.isScanGovernmentIdSuccess = false;
    this.isScanDocumentSuccess = false;
    this.isIdentityComparaisonSuccess = false;
    this.isCheckinSuccess = false;
    this.isIdPictureSuccess = false;
    this.isSelfiePictureSuccess = false;
    this.isPrintBadgeSuccess = false;
    this.isScanQrCodeValidationSuccess = false;
    Object.assign(this, data);
  }
}
